
import { mapState } from 'vuex'
import History from '../-history'
import CtTab from './tab.vue'
import Card from './card.vue'
import LocalCard from './local-card.vue'
import AppointmentDelivery from './appointmentDelivery'
import updateRecipientModal from './updateRecipientModal.vue'
import updateDeliveryPreference from './updateDeliveryPreference.vue'
import RecipientInformation from './recipientInformation'
import { timeZone } from '@/utils/const'
import { parseVocCode, parseCommunicateRemark } from './utils.js'

// opCodes for non-trajectory nodes to exclude from display (global: only 654 this phase)
const EXCLUDED_ROUTE_OP_CODES = ['654']
// Indonesia local shipment: additionally exclude opCode 8000 (keep current behavior)
const INDONESIA_LOCAL_EXCLUDED_OP_CODES = ['8000', '654']

// import Satisfaction from '@/utils/satisfaction/index.vue'

export default {
  components: {
    CtTab,
    Card,
    LocalCard,
    AppointmentDelivery,
    updateRecipientModal,
    updateDeliveryPreference,
    RecipientInformation,
    // Satisfaction
    // Satisfaction
  },
  props: {
    isTab: {
      type: Boolean,
      default: false,
    },
    commonForm: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      queryType: 'international',
      allFold: false,
      foldDom: true,
      form: this.$form.createForm(this, { name: 'waybill' }),
      ticket: '',
      hisData: [],
      isRemember: false,
      routeDataArr: [],
      timeZoneOptions: timeZone,
      timeZoneOptionsTwo: [
        {
          label: this.$t('serviceSupport.querySupport.waybills.localTime'),
          value: '1',
        }, // 当地时间
        {
          label: this.$t('serviceSupport.querySupport.waybills.others'),
          value: '2',
        }, // 其他时间
      ],
      curTimeZoneTwo: '2',
      curTimeZone: '', // 当前选择的时区（实际值，用于查询）
      curTimeZoneDisplay: '', // UTC 选择器的显示值（切换时清空，选择后同步）
      isSearchClicked: false, // 是否点击了查询按钮
      // waybillNo: '',
      loading: false,
      routeDataArrBackup: [],
      showAppointmentDelivery: true,
      tabWaybillIds: '',
      operateType: '2',
      directiveStatus: '', // 指令状态
      timeOptions: [],
      resultRecord: {},
      mobile: '',
      cusId: '',
      checked: false,
      isNoShowCustomerType: false,
      curPhoneCode: '',
      validateCode: '',
      localWaybillNo: '', // 为是欣赝
      communicateTypeIndex: '', // 当前修改的派件方式的索引
      isPseudoLoginVerified: false, // 伪登录验证结果
      pseudoLoginEncryptedPhone: '', // 伪登录加密手机号，传给后端做兜底判断
      isOwnWaybillFlag: false,
    }
  },
  head: {
    script: [
      {
        src: '/tiff.js',
        type: 'text/javascript',
        charset: 'utf-8',
        async: false,
        defer: false,
        hasVerified: false,
        initTimer: null,
        searchTimer: null,
      },
    ],
  },
  computed: {
    ...mapState({
      site: (state) => state.site,
      lang: (state) => state.lang,
      locale: (state) => state.locale,
      isAgree: (state) => state.cookie_agree.agree,
      initTimeZone: (state) => state.support.initTimeZone,
      resizeInfo: (state) => state.resizeInfo,
      loginToken: (state) => state.loginToken,
      loginUser: (state) => state.loginUser,
    }),
    isSgSite() {
      return this.site.toUpperCase() === 'SG'
    },
    isLocalQuery() {
      return this.queryType === 'local'
    },
    curRoute() {
      if (
        !this.routeDataArr ||
        this.routeDataArr.length === 0 ||
        !this.routeDataArr[0]
      )
        return {}
      return this.routeDataArr && this.routeDataArr[0]
    },
    // 当前页面处于预约选择界面
    isSelecting() {
      return this.hasVerified && this.directiveStatus === 'appointmentSelect'
    },
    waybillNo: {
      get() {
        // 如果有手动设置的值，优先使用它
        if (this.localWaybillNo) {
          return this.localWaybillNo
        }
        // 默认值：从查询结果中取第一个运单号
        if (this.routeDataArr[0]?.waybillNo) {
          return this.routeDataArr[0]?.waybillNo
        } else {
          return ''
        }
      },
      set(newValue) {
        // 当你执行 this.waybillNo = 'xxx' 时，会触发这里
        // 但注意：我们不直接修改 routeDataArr，而是用一个本地变量存储
        this.localWaybillNo = newValue
      },
    },
    // 判断是否已登录
    isLoggedIn() {
      return !!(this.loginToken && this.loginUser)
    },
    pseudoLoginParams() {
      const waybillNo = this.$route.query.waybillNo
      const rawPhone = this.$route.query.encryptedPhone || ''
      return {
        waybillNo,
        encryptedPhone: rawPhone ? encodeURIComponent(rawPhone) : '',
      }
    },
    isPseudoLoginMode() {
      return !!(
        this.pseudoLoginParams.waybillNo &&
        this.pseudoLoginParams.encryptedPhone
      )
    },
    // 是否伪登录（用于透传给子组件）
    isPseudoLogin() {
      return this.isPseudoLoginMode
    },
    // 伪登录加密手机号（用于透传给子组件）
    encryptedPhone() {
      return this.pseudoLoginParams.encryptedPhone || ''
    },
  },
  watch: {
    initTimeZone(val) {
      if (val) {
        this.curTimeZone = val
        // 同步设置 UTC 选择器的显示值，确保进入页面时默认选中
        this.curTimeZoneDisplay = val
      }
    },
  },
  mounted() {
    // tab 模式：跳过伪登录、自动填充、自动查询、历史记录初始化
    if (this.isTab) {
      return
    }
    if (this.$route.query.customer_type) {
      this.getCustomerTypeConfig()
    } else {
      this.initialization()
    }
  },
  beforeDestroy() {
    if (this.initTimer) {
      clearTimeout(this.initTimer)
      this.initTimer = null
    }
    if (this.searchTimer) {
      clearTimeout(this.searchTimer)
      this.searchTimer = null
    }
  },
  methods: {
    /**
     * 综合查询页调用：接收公共表单运单号，走国际件查询逻辑
     */
    handleCommonSearch(commonFormData) {
      const ids = commonFormData.ids || ''
      if (!ids) {
        this.$emit('searchComplete')
        return
      }
      this.tabWaybillIds = ids
      this.handleSearch()
    },
    // 切换本地/国际件 tab
    handleTabChange(type) {
      this.queryType = type
      this.routeDataArr = []
      this.routeDataArrBackup = []
      this.form.resetFields()
    },
    async getCustomerTypeConfig() {
      try {
        const list = await this.$API.support.getCustomerTypeConfig()
        if (list.includes(this.$route.query.customer_type)) {
          this.isNoShowCustomerType = true
          // 清理旧定时器（如果存在）
          if (this.initTimer) {
            clearTimeout(this.initTimer)
          }
          this.initTimer = setTimeout(() => {
            this.checked = true
            this.initialization()
          }, 1000)
        } else {
          this.isNoShowCustomerType = false
          this.initialization()
        }
      } catch (error) {
        this.initialization()
      }
    },
    // 伪登录处理
    async handlePseudoLogin() {
      const { waybillNo, encryptedPhone } = this.pseudoLoginParams
      try {
        this.loading = true
        // 自动填充运单号
        this.form.setFieldsValue({ ids: waybillNo })
        // 前置拦截：调用 checkPhoneWaybillRel 判断运单归属
        const res = await this.$API.support.checkPhoneWaybillRel({
          encryptedPhone: decodeURIComponent(encryptedPhone),
          waybillNo,
        })
        this.isPseudoLoginVerified = res?.result === true
        // 保存 encryptedPhone，查询时传给后端做兜底判断
        this.pseudoLoginEncryptedPhone = encryptedPhone
      } catch (error) {
        console.error('伪登录验证失败:', error)
        this.isPseudoLoginVerified = false
      } finally {
        this.loading = false
        // 验证完成后自动触发查询
        this.getData()
      }
    },
    initialization() {
      // 伪登录入口检测
      if (this.isPseudoLoginMode) {
        this.handlePseudoLogin()
        return
      }
      // 从 URL 读取 tab 参数，控制标签页选中状态（仅印尼站生效）
      const { tab } = this.$route.query
      if (tab === '2') {
        this.queryType = 'local'
      }
      this.initHistory()
      const { No } = this.$route.query
      // hash这种只是暂时为老官网老地址出的临时解决方案
      // 例如：/sg/en/dynamic_function/waybill/#search/bill-number/SF2130534511679
      const hash = this.$route?.hash
      if (hash != '#/') {
        // 越南站 当刷新页面时 会自动拼接 #/
        const No1 = hash.substring(hash?.indexOf('SF'))
        if (No || No1) {
          this.form.setFieldsValue({
            ids: No || No1,
          })
          // 清理旧定时器（如果存在）
          if (this.searchTimer) {
            clearTimeout(this.searchTimer)
          }
          this.searchTimer = setTimeout(() => {
            // 确保不是移动端
            if (!this.resizeInfo.isMobile) {
              this.handleSearch()
            }
          }, 500)
        }
      }
    },
    // 查询订单
    handleSearch(isTime) {
      // 判断是否为非切换时间查询场景
      if (typeof isTime !== 'boolean') {
        this.isSearchClicked = true
      }
      const flag = this.handleChecked()
      if (!flag) {
        this.isSearchClicked = false
        if (this.isTab) this.$emit('searchComplete')
        return
      }
      // 已登录用户: 跳过滑块，直接查询
      if (this.isLoggedIn) {
        this.getData()
        return
      }
      // 未登录用户: 需要滑块验证
      this.$parent.$TencentQRCode
        .verify()
        .then((res) => {
          this.getData(res)
        })
        .catch((error) => {
          console.error('腾讯验证码验证失败:', error)
          this.$message.error(
            this.$t(
              'serviceSupport.querySupport.waybills.derificationFailed'
            ) || 'Verification failed. Please try again.'
          )
          if (this.isTab) this.$emit('searchComplete')
        })
    },

    getSplitStr(ids) {
      let str = ids.replace(/[\s]+/g, ',')
      str = str.replace(/，/g, ',')
      if (!this.isTab) {
        this.form.setFieldsValue({
          ids: str,
        })
      }
      return str.split(',')
    },
    handleChecked() {
      const { ids } = this.form.getFieldsValue()
      const finalIds = this.isTab ? this.tabWaybillIds : ids
      // 本地件模式：仅允许单个运单号
      if (this.isLocalQuery) {
        if (!finalIds) {
          this.$message.warn(
            this.$t('serviceSupport.querySupport.waybills.enterWaybills')
          )
          return false
        }
        const orderArr = this.getSplitStr(finalIds)
        if (orderArr.length > 20) {
          this.$message.warn(
            this.$t(
              'serviceSupport.querySupport.waybills.wayBillNumberError'
            )
          )
          return false
        }
        return true
      }
      // tab 模式：固定不走客户订单号逻辑
      if (!this.isTab && this.checked) {
        this.getSplitStr(finalIds)
        return true
      }
      if (!finalIds) {
        this.$message.warn(
          this.$t('serviceSupport.querySupport.waybills.enterWaybills')
        )
        return false
      }
      const orderArr = this.getSplitStr(finalIds)
      if (orderArr.length > 20) {
        this.$message.warn(
          this.$t('serviceSupport.querySupport.waybills.wayBillNumberError')
        )
        return false
      }
      // 非新加坡站点只能输入12位或者15位运单号
      if (!this.isSgSite) {
        for (let i = 0; i < orderArr.length; i++) {
          if (!(orderArr[i].length === 12 || orderArr[i].length === 15)) {
            this.$message.warn(
              this.$t('serviceSupport.querySupport.waybills.wayBillLengthError')
            )
            return false
          }
        }
      } else {
        for (let i = 0; i < orderArr.length; i++) {
          if (![10, 12, 13, 15].includes(orderArr[i].length)) {
            this.$message.warn(
              this.$t('serviceSupport.querySupport.waybills.enterRightWaybills')
            )
            return false
          }
        }
      }
      return true
    },
    // SISP-OS 本地件查询（本地件 tab 统一走 nativeBills 接口）
    getSispData(opts) {
      const { ids } = this.form.getFieldsValue()
      const finalIds = this.isTab ? this.tabWaybillIds : ids
      const orderArr = this.getSplitStr(finalIds)
      // const waybillNo = orderArr[0]
      // 本地件 tab 统一调用 getLocalWaybillData（走 nativeBills 接口 + doResultData 处理）
      // return this.getLocalWaybillData(waybillNo, opts)
      const waybillNos = orderArr.join(',')
      return this.getLocalWaybillData(waybillNos, opts)
    },
    // 获取数据
    async getSfData(opts) {
      try {
        const { ids } = this.form.getFieldsValue()
        const finalIds = this.isTab ? this.tabWaybillIds : ids
        let timeZone = this.curTimeZone
        if (this.curTimeZoneTwo == 1) {
          // 当选择"当地时间"时 timeZone为空，后端按目的地时区返回
          timeZone = ''
        }

        // 检测本地件（印尼 IDP 等本地运单号），自动走 nativeBills 接口
        const isLocalWaybill = this.detectLocalWaybill(finalIds)
        if (isLocalWaybill) {
          return this.getLocalWaybillData(finalIds, opts)
        }

        const urlFn = 'tecentRoutesApi'
        const params = {
          ids: finalIds,
          app: 'bill',
          timeZone,
          isCustomerOrderNo: this.checked,
          // isCustomerOrderNo: true,
          // customer_type: 'test',
          customer_type: this.$route.query.customer_type,
          // 伪登录加密手机号，后端用于兜底运单归属判断
          ...(this.pseudoLoginEncryptedPhone && {
            encryptedPhone: decodeURIComponent(this.pseudoLoginEncryptedPhone),
          }),
          ...opts,
          // ids: 'IUOP1744792549263326',
        }
        this.loading = true
        const res = await this.$API.common[urlFn](params)
        if (res.code === 0) {
          this.doResultData(res.result)
        }
      } catch (e) {
        this.ticket = ''
        console.error('Query waybill data failed:', e)
        this.$message.error(this.$t('common.http.networkError'))
      } finally {
        this.loading = false
        if (this.isTab) this.$emit('searchComplete')
      }
    },
    // 检测是否为本地运单号（不影响国际件判断）
    detectLocalWaybill(ids) {
      if (!ids) return false
      const waybillList = ids
        .replace(/[\s]+/g, ',')
        .replace(/，/g, ',')
        .split(',')
      // 印尼本地件：SFIDP 开头的运单号
      return waybillList.some((no) => /^SFIDP/i.test(no.trim()))
    },
    // 本地件查询（走 nativeBills 接口）
    async getLocalWaybillData(ids, opts) {
      try {
        this.loading = true
        const res = await this.$API.support.sispBarRecordQuery({
          waybillNo: ids.trim(),
          timeZone: this.curTimeZone,
          ...opts,
        })
        this.loading = false
        if (res.code === 0 && res.result) {
          this.doResultData(res.result, true)
        }
      } catch (e) {
        console.error('Query local waybill data failed:', e)
        this.$message.error(this.$t('common.http.networkError'))
      } finally {
        this.loading = false
        if (this.isTab) this.$emit('searchComplete')
      }
    },
    // Check if current query is Indonesia site + local shipment tab
    isIndonesiaLocalShipment(route) {
      // site from URL param (e.g., /id/sc/... → site='id') + "本地件" tab active
      return this.site === 'id' && this.isLocalQuery
    },
    // Filter out non-trajectory route nodes; Indonesia local shipments keep filtering 8000+654
    filterRouteNodes(list, route) {
      if (!Array.isArray(list)) return list
      const excludeCodes = this.isIndonesiaLocalShipment(route)
        ? INDONESIA_LOCAL_EXCLUDED_OP_CODES
        : EXCLUDED_ROUTE_OP_CODES
      return list.filter(
        (item) => !excludeCodes.includes(String(item.opCode))
      )
    },
    doResultData(res, isLocal = false) {
      this.ticket = ''
      let routeDataArr = res || []
      this.allFold = false
      // routeDataArr = routeDataArr.filter((item) => {
      //   return item.destCityName && item.sourceCityName
      // })
      if (routeDataArr.length === 1) {
        routeDataArr[0].isShow = true
        if (isLocal) {
          routeDataArr[0].isLocal = true
        }
        // barNewList 为空时不显示路由数据，状态改为"配送准备中"
        if (!routeDataArr[0].barNewList || routeDataArr[0].barNewList.length === 0) {
          routeDataArr[0].barNewList = []
          routeDataArr[0].awaitingPickup = true
          routeDataArr[0].isShow = false
        } else {
          routeDataArr[0].barNewList = routeDataArr[0].barNewList.reverse()
          routeDataArr[0].barNewList = this.filterRouteNodes(routeDataArr[0].barNewList, routeDataArr[0])
        }
        // 打开满意度
        this.$refs.feedbackRef?.openFeedback()
      } else if (routeDataArr.length === 0) {
        this.$refs.feedbackRef?.closeFeedback()
        const { ids } = this.form.getFieldsValue()
        this.$message.warn(
          this.$t('serviceSupport.querySupport.waybills.noData', [ids])
        )
      } else {
        // 打开满意度
        this.$refs.feedbackRef?.openFeedback()
        routeDataArr.forEach((item) => {
          item.isShow = false
          if (isLocal) {
            item.isLocal = true
          }
          // barNewList 为空时不显示路由数据，状态改为"配送准备中"
          if (!item.barNewList || item.barNewList.length === 0) {
            item.barNewList = []
            item.awaitingPickup = true
          } else {
            item.barNewList = item.barNewList.reverse() // 倒序
            item.barNewList = this.filterRouteNodes(item.barNewList, item)
          }
        })
      }
      if (this.isOwnWaybillFlag) {
        routeDataArr = routeDataArr.map((item) => ({ ...item, isOwn: true }))
        this.isOwnWaybillFlag = false
      }
      this.routeDataArr = routeDataArr
      this.routeDataArrBackup = routeDataArr

      // 用于三星件移动端使用
      this.$store.commit(
        'support/SET_WAWBILL_RESULT',
        JSON.parse(JSON.stringify(routeDataArr))
      )
      this.$emit('track', 'query')
    },
    // SISP-OS opCode 转 opCodeStatus 映射
    mapOpCodeToStatus(opCode) {
      const map = {
        80: 'signed',
        8000: 'signed',
        50: 'collect',
        54: 'pickedup',
        10: 'received',
        20: 'picking',
        30: 'packaged',
        40: 'delivered',
        60: 'delivery',
        70: 'invalid',
      }
      return map[opCode] || 'other'
    },
    // SISP-OS 数据转换：将 BarRecordDto 数组转为 barNewList 格式
    doSispResultData(sispObj, waybillNo) {
      this.ticket = ''
      // sispObj 可能是 { '0': {...}, '1': {...} } 格式或数组
      const items = Array.isArray(sispObj) ? sispObj : Object.values(sispObj)
      if (!items || items.length === 0) {
        this.$message.warn(
          this.$t('serviceSupport.querySupport.waybills.noData', [waybillNo])
        )
        return
      }
      // 按 barScanTs 倒序
      items.sort((a, b) => (b.barScanTs || 0) - (a.barScanTs || 0))
      const barNewList = items.map((item) => {
        // 将 UTC 时间戳转为日期和时间字符串
        const ts = item.barScanTs || 0
        const d = new Date(ts)
        const pad = (n) => String(n).padStart(2, '0')
        const barScanDt = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
          d.getDate()
        )}`
        const barScanTm = `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(
          d.getSeconds()
        )}`
        return {
          waybillNo: item.wayBillNo || waybillNo,
          opCode: item.opCode,
          opCodeStatus: this.mapOpCodeToStatus(item.opCode),
          opName: item.opName,
          remark: item.remark,
          barScanTm,
          barScanDt,
          barScanTs: item.barScanTs,
          zoneGmt: item.zoneGmt,
          distName: item.distName,
          zoneName: item.outsideName || item.zoneName,
          courierCode: item.courierCode,
          empMobile: item.empMobile,
          note: item.note,
          contnrCode: item.contnrCode,
          vehiclePlate: item.vehiclePlate,
          oprCode: item.oprCode,
        }
      })
      const filteredBarNewList = this.filterRouteNodes(barNewList, null)
      const routeDataArr = [
        {
          waybillNo,
          barNewList: filteredBarNewList,
          isShow: true,
          isLocal: true,
        },
      ]
      this.routeDataArr = routeDataArr
      this.routeDataArrBackup = routeDataArr
      this.$store.commit(
        'support/SET_WAWBILL_RESULT',
        JSON.parse(JSON.stringify(routeDataArr))
      )
      this.$emit('track', 'query')
    },
    // 获取数据
    async getData(opts) {
      // 本地件模式：走 SISP-OS 查询
      if (this.isLocalQuery) {
        // 保存本地
        this.saveFormData2Cache()
        // 已登录用户：走归属判断，自己的运单免滑块
        if (this.isLoggedIn) {
          const { ids } = this.form.getFieldsValue()
          await this.validateWaybillRel(ids, opts)
          return
        }
        // 未登录用户需要滑块验证
        if (!this.isLoggedIn && !(opts && opts.ticket)) {
          this.$parent.$TencentQRCode
            .verify()
            .then((cap) => {
              this.getSispData({ ...opts, ...cap })
            })
            .catch((error) => {
              console.error('腾讯验证码验证失败:', error)
              this.$message.error(
                this.$t(
                  'serviceSupport.querySupport.waybills.derificationFailed'
                ) || 'Verification failed. Please try again.'
              )
              if (this.isTab) this.$emit('searchComplete')
            })
          return
        }
        this.getSispData(opts)
        return
      }
      // 保存本地
      this.saveFormData2Cache()
      if (this.isSearchClicked) {
        this.curTimeZone = this.initTimeZone
        this.isSearchClicked = false
      }

      // 新增：获取运单号列表
      const { ids } = this.form.getFieldsValue()
      const waybillList = ids

      // 伪登录模式：根据验证结果决定是否免滑块
      if (this.isPseudoLoginVerified) {
        this.getSfData(opts)
        return
      }

      // 已登录用户：调用 getWaybillRel 判断是否自己的运单
      if (this.isLoggedIn) {
        await this.validateWaybillRel(waybillList, opts)
        return
      }

      // 未登录/普通用户：唤起滑块验证码
      // 如果 opts 已包含验证码结果（来自 handleSearch），直接查询
      if (opts && opts.ticket) {
        this.getSfData(opts)
        return
      }
      this.$parent.$TencentQRCode
        .verify()
        .then((cap) => {
          this.getSfData({ ...opts, ...cap })
        })
        .catch((error) => {
          console.error('腾讯验证码验证失败:', error)
          this.$message.error(
            this.$t(
              'serviceSupport.querySupport.waybills.derificationFailed'
            ) || 'Verification failed. Please try again.'
          )
          if (this.isTab) this.$emit('searchComplete')
        })
    },
    // 运单归属判断（已登录用户）
    async validateWaybillRel(waybillNo, opts) {
      try {
        this.loading = true
        const res = await this.$API.support.getWaybillRel({ waybillNo })
        if (res?.result === true) {
          // 是自己的运单，免滑块直接查询
          if (this.isLocalQuery) {
            this.getSispData(opts)
          } else {
            this.getSfData(opts)
          }
        } else {
          // 不是自己的运单，唤起滑块验证
          this.$parent.$TencentQRCode
            .verify()
            .then((cap) => {
              if (this.isLocalQuery) {
                this.getSispData({...opts, ...cap})
              } else {
                this.getSfData({ ...opts, ...cap })
              }
            })
            .catch((error) => {
              console.error('腾讯验证码验证失败:', error)
              this.$message.error(
                this.$t(
                  'serviceSupport.querySupport.waybills.derificationFailed'
                ) || 'Verification failed. Please try again.'
              )
            })
        }
      } catch (error) {
        console.error('getWaybillRel API failed:', error)
        // API 失败，降级为滑块验证
        this.$parent.$TencentQRCode
          .verify()
          .then((cap) => {
            if (this.isLocalQuery) {
              this.getSispData({...opts, ...cap})
            } else {
              this.getSfData({ ...opts, ...cap })
            }
          })
          .catch((err) => {
            console.error('腾讯验证码验证失败:', err)
            this.$message.error(
              this.$t(
                'serviceSupport.querySupport.waybills.derificationFailed'
              ) || 'Verification failed. Please try again.'
            )
          })
      } finally {
        this.loading = false
      }
    },
    handleTimeChangeTwo(val) {
      if (val == 1) {
        // 切换到"当地时间"：触发验证码+重新查询
        this.handleSearch(true)
      } else {
        // 切换到"其他时间"：清空 UTC 选择器的显示和实际时区值，等用户选择后再查询
        this.curTimeZoneDisplay = ''
        this.curTimeZone = ''
      }
    },
    // 时区切换
    handleTimeChange(val) {
      // 用户选择了具体 UTC 时区，同步到 curTimeZone
      this.curTimeZone = val
      // 触发验证码+重新查询
      this.handleSearch(true)
    },
    saveFormData2Cache() {
      // tab 模式：不存历史搜索
      if (this.isTab) return
      if (this.isRemember) {
        const { ids } = this.form.getFieldsValue()
        this.historyObj.setCache(ids)
      }
    },
    initHistory() {
      this.historyObj = new History({
        site: this.site,
        maxVisibleNum: 4,
        viewContext: this,
        isShowEllipsis: true,
      })
      this.initHisData()
    },
    // 初始化历史查询
    initHisData() {
      this.isAgree ? (this.isRemember = true) : (this.isRemember = false)
      this.hisData = this.historyObj.getShowDateObj()
    },
    handleDeleteHisItem(value) {
      this.historyObj.deleteHistoryItem(value)
    },
    handleChangeNumber(value) {
      this.form.setFieldsValue({
        ids: value,
      })
    },
    // 点击全部收起方法
    clickAllFold() {
      this.allFold = !this.allFold
      this.routeDataArr.filter((item) => {
        return (item.isShow = this.allFold)
      })
    },
    // 点击单个收起方法
    clickFold(index) {
      this.routeDataArr[index].isShow = !this.routeDataArr[index].isShow
      if (
        // 全部都关闭了
        this.routeDataArr.findIndex((target) => target.isShow === true) !== -1
      ) {
        this.allFold = true
      } else if (
        // 全部都打开了
        this.routeDataArr.findIndex((target) => !target.isShow) !== -1
      ) {
        this.allFold = false
      }
    },
    replaceDecodeItems(items, decode = false) {
      items.forEach((item) => {
        this.routeDataArr = this.routeDataArr.map((it) => {
          if (it.waybillNo === item.waybillNo) {
            item.isDecode = decode
            // 反脱敏后恢复城市展示；重新脱敏时恢复隐藏
            item.cityHidden = !decode
            item.isShow = it.isShow
            item.isLocal = it.isLocal
            if (decode && item.barNewList && Array.isArray(item.barNewList)) {
              item.barNewList = item.barNewList.reverse()
            }
            return item
          } else {
            return it
          }
        })
      })
    },
    getReDecode(id) {
      const item =
        this.routeDataArrBackup.find((it) => it.waybillNo === id) || {}
      this.replaceDecodeItems([item])
    },
    decode(items) {
      this.replaceDecodeItems(items, true)
    },
    showUpdateRecipientModal(type, route) {
      // this.dialogVisible = true;
      this.operateType = type // 1 是预约日期  2 是修改收件人信息
      this.$refs.updateRecipientModal.dialogVisible = true
      // this.$refs.updateRecipientModal.showDialogVisible()
      // const { ids } = this.form.getFieldsValue()
      this.waybillNo = route.waybillNo
    },
    showUpdateDeliveryPreference(route, index) {
      const raw = route.communicateType || ''
      if (raw) {
        const { vocCode, gatePassword, remark } = {
          vocCode: parseVocCode(raw),
          ...parseCommunicateRemark(raw),
        }
        this.$refs.updateDeliveryPreference.form.vocCode = vocCode
        if (gatePassword) this.$refs.updateDeliveryPreference.form.gatePassword = gatePassword
        if (remark) this.$refs.updateDeliveryPreference.form.remark = remark
      }
      this.$refs.updateDeliveryPreference.dialogVisible = true
      this.waybillNo = route.waybillNo
      this.communicateTypeIndex = index
    },
    handleVerifySuccess({
      res,
      directiveStatus,
      mobile,
      cusId,
      curPhoneCode,
      validateCode,
    }) {
      this.curPhoneCode = curPhoneCode // 区号
      this.validateCode = validateCode // 验证码
      this.mobile = mobile // 输入的手机号
      this.cusId = cusId //
      console.log('cusId---', this.cusId)
      if (this.operateType == 1) {
        // 预约日期
        this.directiveStatus = directiveStatus
        this.hasVerified = true
        this.timeOptions = res?.operationPlanDates || []
        // this.isSelectingType = this.isSelecting
        switch (directiveStatus) {
          case 'appointmentSelect': // 未预约
            this.resultRecord = {}
            break
          case 'appointmentResult': // 已预约
            this.resultRecord = res.records[0]

            break
        }
        // } else {
        //   // 修改收件人信息
      }
      this.showAppointmentDelivery = false
    },
    handleDeliveryPreferenceSuccess({ vocCode }) {
      // this.handleSearch(true)
      if (this.routeDataArr[this.communicateTypeIndex])
        this.routeDataArr[this.communicateTypeIndex].communicateType = vocCode
    },
    // 点击查询说明  进入查询说明页面
    queryDescription() {
      this.$router.push({
        name: 'site-lang-consulting-queryDescription',
        params: {
          site: this.site,
          lang: this.lang,
        },
      })
    },
  },
}
